<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>
    <div class="page-wrapper">
        <div class="page-content">
            <div class="page-breadcrumb d-sm-flex align-items-center mb-4">
                <!-- <div class="breadcrumb-title pe-3"><span [translate]="'GREATER.FAQ'"> </span></div> -->
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard" ><i class="bx bx-home-alt"></i></a>
                            </li>
                            <!-- <li class="breadcrumb-item active" aria-current="page"><span [translate]="'GREATER.FAQ'"> </span></li> -->
                        </ol>
                    </nav>
                </div>
                <div class="ms-auto">
                    <div class="btn-group ms-2" role="group">
                        <a href="javascript:void(0)" class="btn brandpurpal-btn" routerLink="/add-faq">
                            <span [translate]="'GREATER.ADD_FAQ_QUESTION'"> </span>
                        </a>
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.IMAGE'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.TITLE'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.DESCRIPTION'"> </span></th>                                        
                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of AllData ; let i = index ">
                                        <td scope="row">{{ i + 1 }}</td>
                                        <td><img [src]="item.thumbnail" style="height:100px;width:100px"></td>
                                        <td>{{item.title}}</td>
                                        <td [innerHtml]="item.description"></td>
                                        <td>
                                            <span class="badge bg-success" *ngIf="item.status == 'Active'">{{item.status}}</span>
                                            <span class="badge bg-danger" *ngIf="item.status == 'Deactive'">Danger</span>
                                        </td>
                                        <td>
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-info text-center" (click)="redirect(item,3)">
                                                    <i class="bx bx-pencil"></i>
                                                </button>                                               
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>                         
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
                            <table class="table mb-0 table-hover">
                                <thead>
                                    <tr>
                                        <th scope="col"><span [translate]="'GREATER.NO'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.TYPE'"> </span>.</th>
                                        <th scope="col"><span [translate]="'GREATER.QUESTION'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.ANSWER'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.STATUS'"> </span></th>
                                        <th scope="col"><span [translate]="'GREATER.ACTIONS'"> </span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of dataListing | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount}; let i = index " cdkDrag>
                                        <td scope="row">{{(pageLimit * (p - 1)) + i + 1 }}</td>
                                        <td *ngIf="item.forLoggedIn">With Login</td>
                                        <td *ngIf="!item.forLoggedIn">Without Login</td>
                                        <td>{{item.question}}</td>
                                        <td  [innerHtml]="item.answer"></td>
                                        <td>
                                            <span class="badge bg-success" *ngIf="item.status == 'Active'">{{item.status}}</span>
                                            <span class="badge bg-danger" *ngIf="item.status == 'Deactive'">Danger</span>
                                        </td>
                                        <td>
                                            <div class="btn-group" role="group" aria-label="Basic example">
                                                <button type="button" class="btn btn-info text-center" (click)="redirect(item,1)">
                                                    <i class="bx bx-pencil"></i>
                                                </button>
                                                <!-- <button type="button" class="btn btn-danger text-center" >
                                                    <i class="bx bx-reset"></i>
                                                </button> -->
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                            </div>
                            <div class="pagination-block pt-5">
                                <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" (pageChange)="getDetail((p = $event))" class="text-center" *ngIf="dataListing.length > 0"></pagination-controls>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>